<template>
  <vv-provider tag="div" :rules="rules" v-slot="{ errors, classes }" :name="name" class="form-group">
    <label class="access-form__label">
      {{ label }}
      <abbr title="Ce champ est obligatoire" v-if="isRequired">*</abbr>
    </label>
    <div class="input-group has-icon-left d-block">
      <i class="has-icon-left__icon fa fa-calendar" aria-hidden="true"></i>
      <Datepicker
        ref="datepicker"
        :value="value"
        :language="fr"
        :disabled="disabled"
        :disabledDates="disabledDates"
        :input-class="datepickerCss(classes.invalid)"
        @input="$emit('input', $event)" />
      <i class="has-icon-right__icon fa fa-times text-secondary" @click.prevent="clearDate"></i>
    </div>
    <p class="mb-0">
      <small class="text-danger">{{ errors[0] }}</small>
    </p>
    <small class="text-danger">{{ error }}</small>
  </vv-provider>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import { fr } from 'vuejs-datepicker/dist/locale'

export default {
  name: 'DateInput',
  components: {
    Datepicker
  },
  props: {
    label: String,
    name: String,
    error: String,
    value: {
      type: [String, Date],
      default: null
    },
    rules: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      fr: fr,
      disabledDates: {
        from: new Date()
      }
    }
  },
  computed: {
    isRequired () {
      return _.includes(this.rules, 'required')
    }
  },
  methods: {
    datepickerCss (invalid) {
      let css = 'form-control'
      if (this.error || invalid) css += ' is-invalid'
      return css
    },
    clearDate () {
      this.$refs.datepicker.clearDate()
    }
  }
}
</script>
